import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Label
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

import Hourglass from './Hourglass/Hourglass';

import styles from './CalibrateEngineSpeed.scss';

class CalibrateEngineSpeed extends Component {
  constructor(props) {
    super(props);

    const { screens, routes } = this.props.content;
    const [entryScreen] = screens;

    this.state = {
      entryScreen,
      phase: 0,
      screensButtonConfig: [
        {
          left: {
            destination: routes.left
          },
          center: {
            onClick: this.startCalibrating
          },
          right: {
            destination: routes.right
          }
        },
        {},
        {
          center: {
            onClick: this.returnToStartScreen
          }
        }
      ]
    };
  }

  startCalibrating = () => {
    this.setState({ phase: 1 });

    debounce(
      () => this.setState({ phase: 2 }),
      2000
    )();
  };

  returnToStartScreen = () => {
    this.setState({ phase: 0 });
  }

  render() {
    const {
      entryScreen,
      phase,
      screensButtonConfig
    } = this.state;
    const buttonConfig = screensButtonConfig[phase];

    return [
      <Display key="display">
        <Header>
          <HeaderText value={entryScreen.title} />
        </Header>
        <Content>
          <div className={styles.calibrationWrapper}>
            <Label name={entryScreen.data[phase].label} />
            {phase === 1 && <Hourglass />}
          </div>
        </Content>
        <Footer align={phase === 2 ? 'center' : ''}>
          {phase === 0 && <DisplayButton src="icon-xm-left-arrow" />}
          {phase !== 1 && <DisplayButton src={`icon-xm-${phase === 2 ? 'cycle' : 'enter'}`} />}
          {phase === 0 && <DisplayButton src="icon-xm-right-arrow" />}
        </Footer>
      </Display>,
      <HardwareButtonWrapper key="buttons" config={buttonConfig} />
    ];
  }
}

CalibrateEngineSpeed.propTypes = {
  content: PropTypes.shape({
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired
};

export default CalibrateEngineSpeed;



// WEBPACK FOOTER //
// ./src/screens/Gas/GasSettings/CalibrateEngineSpeed/CalibrateEngineSpeed.js